/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {FETCH_ETEXT_PUBLISH_SUCCESS, FETCH_ETEXT_OPTIMIZE_SUCCESS} from "../_actions/etext.publish.actions";
import moment from "moment/moment";



export const INITIAL_STATE = {
    PRODUCT_CREATION: 'PENDING',
    INITIAL_CONTENT_PROCESSING: 'PENDING',
    CONTENT_PROCESS_STATUS: 'PENDING',
    CONTENT_PUBLISH_MSG: 'PENDING',
    INDEX_BUILD_COMPLETED: 'PENDING',
    SEED_COMPLETED: 'PENDING',
    COURSE_CREATION: 'PENDING',
    INSTANT_PURCHASE_OFFER: 'PENDING',
    FREE_TRIAL_OFFER: 'PENDING',
    INVITE_EMAIL: 'PENDING',
    ACCESS_CARD_OFFER: 'PENDING',
    COURSE_ASSOCIATION: 'PENDING',

    ETEXT_OPTIMIZE_STATUS: 'PENDING'
};

export function etextStatusReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_ETEXT_PUBLISH_SUCCESS: {
            const newObj = {...state};
            action.payload.map(status => {newObj[status.taskType] = status.status + " " + moment(status.createDate).format("MMM Do YYYY hh:mm:ss Z");});
            return newObj;
        }
        case FETCH_ETEXT_OPTIMIZE_SUCCESS: {
            const newObj = {...state};
            newObj["ETEXT_OPTIMIZE_STATUS"] = (action.payload && action.payload.statusDescription) ? action.payload.statusDescription : "PENDING";
            return newObj;
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/etext.status.reducer.js